module.exports = __webpack_public_path__ + "img/bella_vista.0855f918.png";